<div class="d-flex flex-column position-relative form-input  prime-multiple"> 
    <label  class="justify-content-start d-flex">{{label}}
      <span *ngIf="mandatory" class="text-danger">*</span>
    </label>
    <div (focusout)="elementFocused()" [ngClass]="{
      'border-danger': isInerrorState
    }">
    <p-multiSelect [appendTo]="'body'" placeholder="{{placeholder}}" [(ngModel)]="selectedValues" (onFilter)="filterData($event)"  [optionLabel]="'value'" [optionValue]="'value'" [options]="suggestionList" [filter]="false" (onChange)="selectValues($event)" styleClass="d-flex align-items-center position-relative w-100  input-field"  display="chip">
      <ng-template pTemplate="removetokenicon">
        <img alt="dropdown icon" width="16px" height="16px" src="../../../../assets/themes/icons/cancel.svg">
    </ng-template>
    </p-multiSelect>
    </div>
</div>
  